export function formatDateToYMD(date: any) {
  if (date === null) {
    return null;
  }
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, "0"); // add 1 as months are 0-based
  const d = date.getDate().toString().padStart(2, "0");

  return `${y}-${m}-${d}`;
}

export function checkAuth() {
  if (
    typeof localStorage !== "undefined" &&
    (!localStorage.getItem("listings-app-login") ||
      !localStorage.getItem("listings-app-api-token"))
  ) {
    return true;
  } else {
    return false;
  }
}

export function getToken() {
  return typeof localStorage !== "undefined"
    ? localStorage.getItem("listings-app-api-token")
    : "";
}

export function formatDate(timestamp: any) {
  if (timestamp === null) {
    return null;
  }
  let date = new Date(timestamp * 1000);
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return year + "-" + month + "-" + day;
}

export function formatAddress(address: string | undefined) {
  if (address) {
    // Step 1: Removing commas and trimming spaces
    address = address.replace(",", "");

    // Step 2: Splitting the address and the zip code
    const addressParts = address.split(" ");
    const zipCode = addressParts.pop();

    // Step 3: Formatting the address
    let formattedAddress = addressParts.join("-").toLowerCase();

    // Step 4: Removing periods
    formattedAddress = formattedAddress.replace(".", "");

    // Step 5: Constructing the final formatted address
    formattedAddress = `${formattedAddress}_${zipCode}`;

    return formattedAddress;
  } else {
    return "";
  }
}

export function convertToTimestamp(dateString: any) {
  const date = new Date(dateString);
  const utcDate = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
  return Math.floor(utcDate / 1000);
}

export function formatTimestamp(timestamp: any) {
  // Create a new date object using the PHP timestamp
  // PHP timestamps are in seconds, JavaScript Date objects are in milliseconds
  let date = new Date(timestamp * 1000);

  // Extract the month, date, and year from the Date object
  let month = date.getMonth() + 1; // Months are 0-indexed
  let day = date.getDate();
  let year = date.getFullYear();

  // Pad the month and day with leading zeros if necessary
  let monthShow = (month < 10 ? "0" : "") + month;
  let dayShow = (day < 10 ? "0" : "") + day;

  // Format the date in MM-DD-YYYY format
  return monthShow + "-" + dayShow + "-" + year;
}

export function convertTimestampToDaysAgo(timestamp: number): string {
  // Utility function to format time with singular and plural
  const formatTime = (value: number, unit: string): string => {
    return `${value} ${unit}${value > 1 ? "s" : ""} ago`;
  };

  // Convert PHP timestamp to milliseconds by multiplying by 1000
  const dateFromTimestamp = new Date(timestamp * 1000);

  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const diff = currentDate.getTime() - dateFromTimestamp.getTime();

  // Calculate different time intervals
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  // Determine the appropriate string to return with plural handling
  if (seconds < 60) {
    return formatTime(seconds, "second");
  } else if (minutes < 60) {
    return formatTime(minutes, "minute");
  } else if (hours < 24) {
    return formatTime(hours, "hour");
  } else if (days < 7) {
    return formatTime(days, "day");
  } else if (days < 30) {
    return formatTime(weeks, "week");
  } else if (months < 12) {
    return formatTime(months, "month");
  } else {
    return formatTime(years, "year");
  }
}

export function rearrangeArrayById(arr: any[], order: number[]) {
  const idMap = new Map(arr.map((item) => [item.id, item]));
  const rearranged: any[] = [];
  const appended: any[] = [];

  arr.forEach((item) => {
    if (order.includes(item.id)) {
      rearranged[order.indexOf(item.id)] = item;
    } else {
      appended.push(item);
    }
  });

  return rearranged.concat(appended).filter((item) => item !== undefined);
}
